<app-side-menu>
  <div class="card-operator-container">
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <div>
              <h1 class="page-title">
                <i class="fas fa-credit-card me-3"></i>
                Operadora de Cartões
              </h1>
              <p class="page-subtitle">Concilie e visualize transações por operadora</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-operator-card">
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label class="form-label">Operadora:</label>
          <input type="text" class="form-control" [(ngModel)]="operatorName" (change)="onOperatorChange()" placeholder="Ex.: Cielo"/>
        </div>

        <div class="filter-group">
          <label class="form-label">Período:</label>
          <div class="d-flex gap-2">
            <input type="date" class="form-control" [(ngModel)]="startDate" (change)="onDateRangeChange()"/>
            <span class="align-self-center">até</span>
            <input type="date" class="form-control" [(ngModel)]="endDate" (change)="onDateRangeChange()"/>
          </div>
        </div>

        <div class="filter-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
          <button type="button" class="btn btn-primary ms-2" (click)="openNew()">
            <i class="fas fa-plus me-2"></i>
            Novo
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="showForm" class="mt-3">
      <div class="card p-3">
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Data</label>
            <input type="date" class="form-control" [(ngModel)]="formData.date"/>
          </div>
          <div class="col-md-3">
            <label class="form-label">Operadora</label>
            <input type="text" class="form-control" [(ngModel)]="formData.operator"/>
          </div>
          <div class="col-md-3">
            <label class="form-label">Descrição</label>
            <input type="text" class="form-control" [(ngModel)]="formData.description"/>
          </div>
          <div class="col-md-2">
            <label class="form-label">Valor</label>
            <input type="number" class="form-control" [(ngModel)]="formData.amount"/>
          </div>
          <div class="col-md-1">
            <label class="form-label">Status</label>
            <select class="form-select" [(ngModel)]="formData.status">
              <option *ngIf="loadingStatuses" disabled>Carregando...</option>
              <option *ngFor="let status of statusOptions" [value]="status.name">{{ status.name }}</option>
            </select>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button type="button" class="btn btn-outline-secondary me-2" (click)="cancelForm()">Cancelar</button>
          <button type="button" class="btn btn-success" (click)="submitForm()">{{ editMode ? 'Salvar' : 'Criar' }}</button>
        </div>
      </div>
    </div>

    <div *ngIf="!loading && !error && transactions.length > 0" class="table-content">
      <app-table
        [title]="tableTitle"
        [columns]="columns"
        [data]="transactions"
        [loading]="loading"
        [showSearch]="showSearch"
        [searchPlaceholder]="searchPlaceholder"
        [clickable]="clickable"
        [actions]="actions"
        [enableSorting]="true"
        [clientSideSort]="true"
        (actionClick)="onActionClick($event)"
        (searchChange)="onSearch($event)">
      </app-table>
    </div>

    <div *ngIf="!loading && !error && transactions.length === 0" class="empty-state">
      <i class="fas fa-file-invoice-dollar"></i>
      <h3>Nenhuma transação encontrada</h3>
      <p>Informe filtros para listar as transações da operadora.</p>
    </div>

<div *ngIf="error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>
    </div>
  </div>
</app-side-menu>
